// #region Imports

import Vue from 'vue';

// #endregion

// #region Component Registration

Vue.component('ApiDashboardPage', () => import(/* webpackChunkName: "api-pages" */ '@/apps/api/pages/ApiDashboardPage.vue'));
Vue.component('ApiExternalSystemsPage', () => import(/* webpackChunkName: "api-pages" */ '@/apps/api/pages/ApiExternalSystemsPage.vue'));
Vue.component('ApiExternalSystemsCreatePage', () => import(/* webpackChunkName: "api-pages" */ '@/apps/api/pages/ApiExternalSystemsCreatePage.vue'));
Vue.component('ApiConnectionsPage', () => import(/* webpackChunkName: "api-pages" */ '@/apps/api/pages/ApiConnectionsPage.vue'));
Vue.component('ApiConnectionsCreatePage', () => import(/* webpackChunkName: "api-pages" */ '@/apps/api/pages/ApiConnectionsCreatePage.vue'));
Vue.component('ApiApiLogsPage', () => import(/* webpackChunkName: "api-pages" */ '@/apps/api/pages/ApiApiLogsPage.vue'));

// #endregion
